import { useState, useContext } from "react"
import validateValues from "./validateValues"
import { useNavigate, useParams } from "react-router-dom"
import AuthContext from "./AuthProvider"




function useForm(initialValues,) {
    const [values, setValues] = useState(initialValues)
    const [errors, setErrors] = useState({})
    const navigate = useNavigate(); 
    const [message, setMessage] = useState('')
    const [errmsg, seterrmsg] = useState('')
    const {setUser} = useContext(AuthContext);
    const { token, id } = useParams();


    const handleChange = (e) => {
        const {name, value} = e.target

        setValues({
          ...values,
          [name]: value 
         
      })
        const inputValue = name === 'password' || name === 'confirm_password' || name === 'old_password' || name === 'new_password' || name === 'confirm_new_password' ? {
            password:  name === 'password' ? value:  values?.password,
            confirm_password: name === 'confirm_password' ? value:  values?.confirm_password,
            new_password:  name === 'new_password' ? value:  values?.new_password,
            confirm_new_password: name === 'confirm_new_password' ? value:  values?.confirm_new_password,
            old_password: name === 'old_password' ? value: values?.old_password
        } : {
            [name]: value 
        }

      const validate =  validateValues(inputValue)
      if(validate[name]){
        setErrors({
            ...errors,
            [name]: validate[name]
        })
      }else{
        setErrors(prevState => {
            delete prevState[name]
            return prevState
        })
      }
    }

     const newUser = async (values) => {
      const signUpOptions = {
      method: 'POST',
      headers: {
         "Content-Type" : "application/json",
         "Accept": "application/json"
        },
      body: JSON.stringify(values)
  }
    await fetch(`${process.env.REACT_APP_API_URL}/auth/register`, signUpOptions)
    .then(response => response.json())
     .then(data => {
       if (data){
         setTimeout(() => {
          setMessage('');
          navigate(`/verifyemail/${data.user_id}`)
        }, 3000)
        setMessage('Registration Successful! Kindly head to your mail to complete registration');
       }else {
        setTimeout(() => {
          seterrmsg('');
        }, 5000)
        seterrmsg('An error occurred');
       }
     })
     .catch(err => {
      console.log(err)
      setTimeout(() => {
        seterrmsg('');
      }, 10000)
      seterrmsg('Something went wrong!');
    })
  } 

 

  

    const handleUserSignIn = async (values) => {
        const loginOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(values)
        };
        await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, loginOptions)
            .then( response =>  response.json())
            .then(data => { 
              if(data.msg === 'Incomplete registration error'){
                setUser(null)
                setTimeout(() => {
                  navigate(`/verifyemail/${data.user_id}`)
                },1000)
                navigate("/loading")
            }else if(data.user){
                const userId = data.accessToken;
                setUser(userId)
                setMessage('Login Successful, you will be redirected to your dashboard')
                setTimeout(() => {
                      navigate(`/dashboard/${data.user.username}/${userId}/${data.user.id}`)
                },1000)
                  navigate("/loading")
            } else if(data.msg === "Invalid credentials"){
                setUser(null)
                setTimeout(() => {
                     seterrmsg('')
                }, 3000)
                seterrmsg('Incorrect Password')
              }else{
                setTimeout(() => {
                    navigate('/signup')
                },5000)
                seterrmsg('User does not exist, Redirecting you to sign up page')
              }
            })
            .catch(err => {
              console.log(err)
              setTimeout(() => {
                seterrmsg('');
              }, 10000)
              seterrmsg('Something went wrong!');
            })
      } 




      const userResetPassword = async (token, id ,values) => {
        const signUpOptions = {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(values)
      };
        await fetch(`${process.env.REACT_APP_API_URL}/auth/reset-password/${id}/${token}`, signUpOptions)
           .then( response => response.json())
            .then(data => {
             if(data){
              setTimeout(() => {
                setMessage('');
              }, 10000)
              setMessage('Password has been reset successfully');
             }else{
              setTimeout(() => {
                seterrmsg('');
              }, 10000)
              seterrmsg('An error occurred');
             }
            })
            .catch(err => {
              console.log(err)
              setTimeout(() => {
                seterrmsg('');
              }, 10000)
              seterrmsg('Something went wrong!');
            })
      } 

      const changePassword = async (values, token) => {
        const changeOptions = {
          method: 'PATCH',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
           },
          body: JSON.stringify(values)
      };
        await fetch(`${process.env.REACT_APP_API_URL}/auth/change-password`, changeOptions)
           .then( response => response.json())
            .then(data => {
              if (data){
                setTimeout(()=>{
                  setMessage('')
                  window.location.reload()
                },5000)
                setMessage('Password has been sucessfully changed')
              }
                else{
              setTimeout(()=>{
                seterrmsg('')
              },5000)
              seterrmsg('An error occured, please try again later!')
            }
          })
            .catch(err => {
              console.log(err)
              setTimeout(()=>{
                seterrmsg('')
              },5000)
              seterrmsg('Something went wrong!')
            })
      } 


   

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrors(validateValues(values))
        const submitErrors = validateValues(values)
        if(Object.keys(submitErrors).length){
          return
        } else if(Object.keys(values).length === 2 && values.email){
          handleUserSignIn(values);
        }else if (values.username){
          setTimeout(() => {
            setMessage('');
          }, 2000)
          setMessage('Loading...')
          newUser(values);
        }else if (values.old_password){
          changePassword(values, token)
      } else{
            userResetPassword(token, id, values);
        }
      }



    

    return {handleChange, values, handleSubmit, errors, setErrors, handleUserSignIn, message,errmsg, setMessage, seterrmsg}
    }

export default useForm
